module.exports = __webpack_public_path__ + "static/img/settingsucesse2.82f982dc.jpg";